import type { Api } from "../types";

// Документы о соответствии в моках консоли: ничего не требуется, нечего снимать.
export const compliance: Api["compliance"] = {
	async summary() {
		return { publishedMissing: 0, moderationMissing: 0, held: 0, requiredCategories: 0 };
	},
	async unpublishMissing() {
		return { count: 0, shops: 0 };
	},
	async applyRecommended() {
		return { updated: [] };
	},
	async setCategory(_id, input) {
		return { required: input.required === true, kinds: [], sourceCategoryId: null };
	},
	async rejectDocument() {
		throw new Error("В моках документов о соответствии нет");
	},
	async documentFile() {
		return new Blob(["%PDF-1.4\n"], { type: "application/pdf" });
	},
	async listDocuments(query) {
		return {
			data: [],
			counts: { pending: 0, approved: 0, rejected: 0 },
			meta: { page: query.page ?? 1, pageSize: query.pageSize ?? 50, total: 0, totalPages: 0 },
		};
	},
	async getDocument() {
		throw new Error("В моках документов о соответствии нет");
	},
	async documentProducts() {
		return [];
	},
	async approveDocument() {
		throw new Error("В моках документов о соответствии нет");
	},
	async admit() {
		throw new Error("В моках допуска нет");
	},
	async revokeAdmission() {
		throw new Error("В моках допуска нет");
	},
	async report() {
		return { total: 0, byShop: [], byCategory: [], items: [] };
	},
	async reportCsv() {
		return { blob: new Blob(["\uFEFFМагазин;Товар\r\n"], { type: "text/csv" }), filename: "Товары без документа.csv" };
	},
	async journal() {
		return { data: [], meta: { page: 1, pageSize: 50, total: 0, totalPages: 0 } };
	},
	async matrix() {
		return [];
	},
};
